export default __webpack_public_path__ + "static/media/supplier2.41392b37.png";